import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import { UserAdmin } from '../../../models/UserAdmin'
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from '../../../services/notification.service'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { UserService } from '../../../services/user.service'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { IRoles, UserCreate } from 'src/app/models/User'
import { removeToolTip, rolesArbolink } from 'src/app/_helpers/Utils'

@Component({
	selector: 'app-admin',
	templateUrl: './admin.component.html'
})
export class AdminComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild(DataTableDirective) public dtElement: DataTableDirective
	public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}
	public users: Array<UserCreate> = []
	public userAdmin: UserCreate = new UserCreate()
	public sessionUser: UserAdmin = getLoggedUser()
	public roles: Array<IRoles> = rolesArbolink
	public open: boolean = false
	public emailUser: string
	public loading: boolean = false
	public isLoading: boolean = false
	public disableCpfAndEmail: boolean = false
	public ViewValidation: ViewValidation = new ViewValidation()
	public telephoneMask: string = '(00) 0000-00009'

	public openBlockUsers: boolean = false
	public openUnblockUsers: boolean = false
	public checkedBlockedUsers: Array<string> = []
	public checkedUnblockedUsers: Array<string> = []
	public usersSelected: Array<string> = []

	constructor(
		public notificationService: NotificationService,
		private userAdminService: UserService,
		private activateRoute: ActivatedRoute
	) {}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	public ngOnInit(): void {
		this.getUsersAdminResolver()
		this.setupDatatables()
	}

	public getUsersAdminResolver(): void {
		this.users = this.activateRoute.snapshot.data.admins

		this.rerender()
	}

	private setupDatatables(): void {
		this.datatableOptions = {
			language: {
				url: '//cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json'
			},
			pagingType: 'full_numbers',
			paging: true,
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: 10,
			lengthChange: false,
			columnDefs: [
				{
					targets: 'no-sort',
					orderable: false,
					width: '.1%'
				}
			]
		}
	}

	private changeUserStatus(user: UserAdmin): void {
		this.userAdminService.changeUserStatus(user._id).subscribe(() => console.log('Status changed'))
		user.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
	}

	public async getUsersAdmin(): Promise<void> {
		try {
			this.users =
				await this.userAdminService.getUsers({
					companyId: 'GENERAL_ADMIN',
					role: 'GENERAL_ADMIN'
				}).toPromise()

			this.rerender()
		} catch (err) {
			console.log(err)
		}
	}

	public async unblockUser(user: UserAdmin, index: number): Promise<void> {
		try {
			removeToolTip()
			const response =
				await this.userAdminService.unblockUsers([user._id]).toPromise()
			this.notificationService.notify(response.message, 200)
			this.users[index].blocked = false
			this.checkedBlockedUsers = this.checkedBlockedUsers.filter(id => id !== user._id)
			this.usersSelected = this.usersSelected.filter(id => id !== user._id)
		} catch (err) {
			console.log(err)
		} finally {
			setTimeout(() => {
				removeToolTip()
			}, 1000)
		}
	}

	public async blockUser(user: UserAdmin, index: number): Promise<void> {
		try {
			removeToolTip()
			const response =
				await this.userAdminService.blockUsers([user._id]).toPromise()
			this.notificationService.notify(response.message, 200)
			this.users[index].blocked = true
			this.checkedUnblockedUsers = this.checkedUnblockedUsers.filter(id => id !== user._id)
			this.usersSelected = this.usersSelected.filter(id => id !== user._id)
		} catch (err) {
			console.log(err)
		} finally {
			setTimeout(() => {
				removeToolTip()
			}, 1000)
		}
	}

	public async blockManyUsers() {
		try {
			const response =
				await this.userAdminService.blockUsers(this.checkedUnblockedUsers).toPromise()
			this.notificationService.notify(response.message, 200)
			this.usersSelected = this.usersSelected.filter(id => !this.checkedUnblockedUsers.includes(id))
			this.checkedUnblockedUsers = []
			await this.getUsersAdmin()
			this.closeModalBlockUsers()
		} catch (err) {
			console.log(err)
		}
	}

	public async unblockManyUsers() {
		try {
			const response =
				await this.userAdminService.unblockUsers(this.checkedBlockedUsers).toPromise()
			this.notificationService.notify(response.message, 200)
			this.usersSelected = this.usersSelected.filter(id => !this.checkedBlockedUsers.includes(id))
			this.checkedBlockedUsers = []
			await this.getUsersAdmin()
			this.closeModalUnblockUsers()
		} catch (err) {
			console.log(err)
		}
	}

	public uncheckUser(user: UserAdmin, index: number) {
		if (user.blocked) {
			this.checkedBlockedUsers.splice(this.checkedBlockedUsers.indexOf(user._id), 1)
		} else {
			this.checkedUnblockedUsers.splice(this.checkedUnblockedUsers.indexOf(user._id), 1)
		}
		this.usersSelected.splice(this.usersSelected.indexOf(user._id), 1)
	}

	public checkUser(user: UserAdmin, index: number) {
		if (user.blocked) {
			this.checkedBlockedUsers.push(user._id)
		} else {
			this.checkedUnblockedUsers.push(user._id)
		}
		this.usersSelected.push(user._id)
	}

	public closeModalBlockUsers(): void {
		this.openBlockUsers = false
	}

	public openModalBlockUsers(): void {
		if (this.checkedUnblockedUsers.length == 0) {
			return
		}
		this.openBlockUsers = true
	}

	public closeModalUnblockUsers(): void {
		this.openUnblockUsers = false
	}

	public openModalUnblockUsers(): void {
		if (this.checkedBlockedUsers.length == 0) {
			return
		}
		this.openUnblockUsers = true
	}

	public async newAdmin(): Promise<void> {
		try {
			const response: any =
				await this.userAdminService.addUser(this.userAdmin).toPromise()
			this.refreshNewUser()
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public async editAdmin(): Promise<void> {
		try {
			const response: any =
				await this.userAdminService.patchUser(this.userAdmin).toPromise()

			this.refreshNewUser()
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public async updateUserStatus(): Promise<void> {
		try {
			const response: any =
				await this.userAdminService.changeUserStatus(this.userAdmin._id).toPromise()
			this.refreshNewUser()
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			console.log(err)
		}
	}

	public async resendEmail(user: UserAdmin): Promise<void> {
		try {
			const response: any =
				await this.userAdminService.sendEmail(user._id).toPromise()
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			console.log(err)
		}
	}

	public getStatus(): string {
		if (this.userAdmin.status === 'ACTIVE') {
			return 'Ativo'
		}

		return 'Pendente'
	}

	public handleSync(event: any): any {
		event.target.className = 'sync'
		setTimeout(() => {
			event.target.className = ''
		}, 2000)
	}

	public openModal(): void {
		this.open = true
		this.userAdmin = new UserCreate()
	}

	public editModal(userSelected: UserCreate): void {
		this.open = true
		this.disableCpfAndEmail = !Boolean(this.sessionUser._id == userSelected._id)
		this.userAdmin = userSelected
		setTimeout(() => {
			this.telMask(this.userAdmin.telephone)
		}, 250)
	}

	public closeModal(): void {
		this.open = false
	}

	public telMask(value: any): void {
		if (value.length === 15) {
			this.telephoneMask = '(00) 00000-0000'

			return
		}
		if (value.length < 15) {
			this.telephoneMask = '(00) 0000-00009'

			return
		}
	}

	public refreshNewUser(): void {
		this.closeModal()
		this.getUsersAdmin()
		this.userAdmin = new UserCreate()
	}

	public rerender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public ngOnDestroy(): void {
		if (this.refreshTable) this.refreshTable.unsubscribe()
	}
}
